export default __webpack_public_path__ + "static/bg-b114d3b229dd0a2c4d7377cf521f852c.jpg";